"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLocale = 'en-us';
var rightToLeftLocales = ['he-il', 'ar-il'];
exports.isRightToLeft = function (locale) { return rightToLeftLocales.includes(locale.toLowerCase()); };
exports.isAmPm = function (locale) {
    return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).resolvedOptions().hour12;
};
exports.getLocale = function (locale, rtlEnabled) {
    if (rtlEnabled === void 0) { rtlEnabled = false; }
    return locale && (rtlEnabled || !exports.isRightToLeft(locale)) ? locale : exports.defaultLocale;
};
exports.isRtlLanguage = function (language) {
    if (language === void 0) { language = 'en'; }
    return ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'].includes(language);
};
